/**
 * InviteCodePage.tsx — invite code redemption page
 *
 * Purpose:    Verify and redeem an ɳSentry invite code, then show account creation form
 * Inputs:     :code URL param from React Router
 * Outputs:    InviteRedeemPage component with code prop; redirects bare /invite/code to /invite
 * Constraints: Client-side only; redirect via React Router Navigate
 * SOT:        T-P3-E3-W2-S5-T01
 */
import { useParams, Navigate } from 'react-router-dom'
import { InviteRedeemPage } from '../components/InvitePage/InviteRedeemPage'

export function InviteCodePage() {
  const { code } = useParams<{ code: string }>()

  // No code or bare "code" sentinel → redirect to waitlist
  if (!code || code === 'code') {
    return <Navigate to="/invite" replace />
  }

  return (
    <section className="mx-auto max-w-md px-4 py-20 sm:px-6">
      <div className="mb-8 text-center">
        <h1 className="mb-3 text-3xl font-bold">You are invited</h1>
        <p className="text-brand-muted">
          You have been invited to join ɳSentry early access. Create your account below to get access.
        </p>
      </div>

      <div className="rounded-xl border border-brand-subtle bg-brand-surface/50 p-8">
        <InviteRedeemPage code={code} />
      </div>
    </section>
  )
}
